import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {
  ClientaApiResponse,
  GroupMemberNewReqDto,
  GroupMemberNewResDto,
  GroupNewReqDto
} from '../../../shared/model/group-new.model';

@Injectable({
  providedIn: 'root'
})
export class GroupApiService {
  private readonly baseURL = environment.baseUrl + 'group_new';

  constructor(private http: HttpClient) {
  }

  /** GET /web/group_new/event/{eventId} — all groups for event */
  getGroups(eventId: number | string): Observable<ClientaApiResponse<GroupNewReqDto[]>> {
    return this.http.get<ClientaApiResponse<GroupNewReqDto[]>>(`${this.baseURL}/event/${eventId}`);
  }

  /** GET /web/group_new/event/{eventId}/group/{groupId} — one group */
  getGroup(eventId: number | string, groupId: number | string): Observable<ClientaApiResponse<GroupNewReqDto>> {
    return this.http.get<ClientaApiResponse<GroupNewReqDto>>(`${this.baseURL}/event/${eventId}/group/${groupId}`);
  }

  /** POST /web/group_new/event/{eventId} */
  saveGroup(eventId: number | string, body: GroupNewReqDto): Observable<ClientaApiResponse> {
    return this.http.post<ClientaApiResponse>(`${this.baseURL}/event/${eventId}`, body);
  }

  /** PUT /web/group_new/event/{eventId} */
  updateGroup(eventId: number | string, body: GroupNewReqDto): Observable<ClientaApiResponse> {
    return this.http.put<ClientaApiResponse>(`${this.baseURL}/event/${eventId}`, body);
  }

  /**
   * GET /web/group_new/member/event/{eventId} — all members for event
   * GET /web/group_new/member/event/{eventId}?groupNewId={id} — members of one group
   */
  getMembers(
    eventId: number | string,
    groupNewId?: number | string | null
  ): Observable<ClientaApiResponse<GroupMemberNewResDto[]>> {
    let params = new HttpParams();
    if (groupNewId != null && groupNewId !== '' && groupNewId !== 'all') {
      params = params.set('groupNewId', String(groupNewId));
    }
    return this.http.get<ClientaApiResponse<GroupMemberNewResDto[]>>(
      `${this.baseURL}/member/event/${eventId}`,
      {params}
    );
  }

  /** GET /web/group_new/member/event/{eventId}/member/{memberId} — one member */
  getMember(
    eventId: number | string,
    memberId: number | string
  ): Observable<ClientaApiResponse<GroupMemberNewResDto>> {
    return this.http.get<ClientaApiResponse<GroupMemberNewResDto>>(
      `${this.baseURL}/member/event/${eventId}/member/${memberId}`
    );
  }

  /** POST /web/group_new/member/event/{eventId} */
  saveMember(eventId: number | string, body: GroupMemberNewReqDto): Observable<ClientaApiResponse> {
    return this.http.post<ClientaApiResponse>(`${this.baseURL}/member/event/${eventId}`, body);
  }

  /** PUT /web/group_new/member/event/{eventId} */
  updateMember(eventId: number | string, body: GroupMemberNewReqDto): Observable<ClientaApiResponse> {
    return this.http.put<ClientaApiResponse>(`${this.baseURL}/member/event/${eventId}`, body);
  }

  /** DELETE /web/group_new/delete/group/{groupId}/event/{eventId} */
  deleteGroup(eventId: number | string, groupId: number | string): Observable<ClientaApiResponse> {
    return this.http.delete<ClientaApiResponse>(`${this.baseURL}/delete/group/${groupId}/event/${eventId}`);
  }

  /** DELETE /web/group_new/delete/member/{memberId}/event/{eventId} */
  deleteMember(eventId: number | string, memberId: number | string): Observable<ClientaApiResponse> {
    return this.http.delete<ClientaApiResponse>(`${this.baseURL}/delete/member/${memberId}/event/${eventId}`);
  }
}
